var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.client_id
    ? _c("input", {
        attrs: { type: "hidden", name: _vm.name },
        domProps: { value: _vm.client_id },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }